import "./item.css";
import { OperationItemProps } from "./item.props";

const OperationItem: React.FC<OperationItemProps> = (props) => {
  return (
    <>
      <div className="operation-item-wrapper">
        {props.title && (
          <small className="operation-item-title">{props.title}</small>
        )}
        <p className="operation-item-text">{props.text}</p>
      </div>
    </>
  );
};

export default OperationItem;